<template>
  <div class="u-flex rhe-table">
    <div class="u-flex">
      <div
        :id="`tab${key}`"
        @click="tabclick(key, index)"
        class="rhe-tb-item pot"
        :class="{
          'tab-right-none': key == 0 ,
          'left-none': isLenght(key),
          pitch: key == check,
        }"
        v-for="(index, key) in list"
        :key="key"
      >
        {{ index }}
      </div>
    </div>
    <div class="botton-line"></div>
  </div>
</template>
<script>
import toRoleName from "@/mixins/roleName";
import ls from "store2";
export default {
  props: ["value", "list"],
  mixins: [toRoleName],
  data() {
    return {
      check: 0,
    };
  },
  computed: {
    isLenght() {
      return (key) => {
        let len = this.list.length - 1;

        if(len<2){
          return false
        }else if (key == len) {
          return true;
        } else {
          return false;
        }
      };
    },
  },
  mounted() {},
  methods: {
    tabclick(index, string) {
      this.check = index;
      let obj = {
        index,
        string,
      };
      this.$emit("input", obj);
    },
  },
};
</script>

<style lang="less">
.rhe-table {
  width: 100%;
  align-items: flex-end;
  .botton-line {
    width: 100%;
    border-bottom: 1px solid #dedede;
  }
  .rhe-tb-item {
    // width: 145px;
     height: 36px;
     padding: 0px 24px;
    opacity: 1;
    border: 1px solid #dedede;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    white-space: nowrap;
  }

  .pitch {
    border-bottom: none;
    border-top: 3px solid #0c479d;
    font-weight: 400;
    color: #0c479d;
   
  }

  .left-none {
       border-left: none
  }

  .tab-right-none {
    border-right: none;
  }
}
</style>